<template>
  <v-container fluid class="campaigns-overview">
    <v-layout row wrap class="py-0 my-0">
      <v-flex v-if="campaign">
          <span class="template-title">
            {{ campaign.name }}
        </span>
        </v-flex>
      <v-spacer class="py-0 my-0"/>
        <schedule-campaign
        class="py-0 my-0"
          v-if="campaign"
          style="width: auto"
          :campaign="campaign"
          @success="getCampaignData"
          @updated="getCampaignData"/>

      </v-layout>
    <v-layout row wrap>
      <v-flex xs6>
        <overall-campaigns-pie-chart :overall-data="overallData.msg_status" v-if="overallData.msg_status"/>
      </v-flex>
      <v-flex xs6>
        <reply-back-status :reply-back-status="overallData.replyback_status" v-if="overallData.replyback_status"/>
      </v-flex>
      <v-flex xs12>
        <receivers view="overview" />
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import overallCampaignsPieChart from "../sections/insights/overallCampaignsPieChart";
  import receivers from '../receivers-crud'
  import replyBackStatus from "./replyBackStatus";
  import ScheduleCampaign from '@/components/campaign-manager/campaigns-crud/ScheduleCampaign'
  export default {
    name: "campaign-overview",
    components: {
      overallCampaignsPieChart,
      receivers,
      replyBackStatus,
      ScheduleCampaign,
    },
    data() {
      return {
        overallData: {},
        campaign: null
      }
    },
    mounted() {
      this.getInsights()
      this.getCampaignData()
    },
    methods: {
      getInsights() {
        this.$http_chat.get(`/campaigns/${this.$route.params.id}/analytics`)
          .then(res=>{
            this.overallData = res.data.data
          })
          .catch(err=>{

          })
      },
      getCampaignData() {
      this.$store.dispatch('setLoader', true)
      this.$http_chat.get(`/campaigns/${this.$route.params.id}`).then(res => {
        // console.log('ca', res.data)
        this.campaign = res.data.data
        
        this.$store.commit('campaigns/select', res.data.data)
        
        this.$store.dispatch('setLoader', false)
      }).catch(()=> {
        this.$store.dispatch('setLoader', false)
        this.$store.dispatch('setErrorMessage', true)
      })
    },
    }
  }
</script>

<style scoped>

</style>
